import React, { Component } from "react";

import Loading from "../../components/Loading";
import Base from "../../components/Base";
import StatsWidget from "./components/StatsWidget";
import PastaInfos from "./components/PastaInfos";
import FiltroBase from "./components/FiltroBase";

import api from "../../services/api";
import handleError from "../../services/apiErrorHandler";

import { notification, Alert } from "antd";

import "./styles.css";

export default class Filtro extends Component {
  state = {
    pasta: null,
    loading: true,
    error: null,
    success: false
  };

  async componentDidMount() {
    /**
     * Ao carregar o componente,
     * obtém uma nova pasta do back-end para filtro.
     */
    let pasta = "";
    console.log(this.props);
    if (this.props.location.state != undefined) {
      console.log(this.props.location.state.pasta.pasta);
      pasta = "?p=" + this.props.location.state.pasta.pasta;
      this.props.location.state = undefined;
    }
    await api
      .get("/filtro/" + pasta)
      .then(response => {
        const resp = response.data;

        if (resp.pasta_to_filter != null) {
          // Salva as informações no estado
          this.setState({
            pasta: resp,
            success: true
          });
        }
      })
      .catch(error => {
        notification.error({ message: handleError(error) });
      });

    this.setState({
      loading: false
    });
  }

  render() {
    let component = null;
    let filtro_form = null;

    // Loading
    if (this.state.loading) component = <Loading />;
    // Caso ocorra algum erro na busca pelo filtro, mostra o erro na tela
    else if (this.state.error)
      component = <Alert message={this.state.error} type="error" />;
    // Sem pastas para filtrar
    else if (this.state.pasta == null)
      component = (
        <Alert message="Não há pastas para serem filtradas." type="warning" />
      );
    else if (this.state.success) {
      // Informações da pasta
      component = <PastaInfos pasta={this.state.pasta} />;
      // Formulário do filtro
      filtro_form = <FiltroBase pasta={this.state.pasta.pasta_to_filter} />;
    }

    // Filtro
    return (
      <Base title="Filtro">
        {/** Componente que mostra as pastas restantes para filtar, pastas filtradas no dia e no mês */}
        <StatsWidget />
        <br />
        {/** Componente com informações da pasta */}
        {component}

        {/** Componente do formulário */}
        {filtro_form}
      </Base>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Filtro/index.js